function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperplaneright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.137 2.03A1.55 1.55 0 002.92 3.903L5.9 12.25l-2.98 8.347a1.55 1.55 0 002.217 1.873l15.835-8.868a1.55 1.55 0 000-2.704zm14.976 10.22L4.47 3.49l2.771 7.76h5.508a1 1 0 110 2H7.242l-2.77 7.76z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgPaperplaneright;